module.exports = __webpack_public_path__ + "assets/img/gift_1.f9105c64.svg";